<div class="row justify-content-center">
    <!-- <div class="col-lg-2 col-md-2 col-6 text-center py-4" *ngFor="let data of clients_logo"> -->
        <div class="{{brand_class}}" *ngFor="let data of clients_logo">
        <img src="{{data.image}}" class="avatar avatar-ex-sm" alt="">
    </div>
</div>